import { WebinarCard } from "./WebinarCard";

const currentDate = new Date();

export const WebinarsList = ({ webinars, loading }) => {
  const sortedWebinars = webinars?.sort(function (a, b) {
    let dateA = new Date(a.date);
    let dateB = new Date(b.date);
    if (dateA < dateB) return 1;
    if (dateA > dateB) return -1;
    return 0;
  });
  const filteredWebinars = {
    upcomingWebinars: sortedWebinars?.filter(webinar => {
      const date = new Date(webinar.date);
      return date > currentDate && webinar.webinar_registration_link !== "";
    }),
    onDemandWebinars: sortedWebinars?.filter(webinar => {
      const date = new Date(webinar.date);
      return date < currentDate;
    }),
  };
  return (
    <section className="webinars_list">
      <section className="webinars_list-main">
        <section className="section-layout">
          <section className="webinars_list-list">
            {filteredWebinars?.upcomingWebinars?.reverse().map((webinar, webinarIndex) => {
              const date = new Date(webinar.date);
              if (
                (date > currentDate && webinar.webinar_registration_link !== "") ||
                date < currentDate
              ) {
                return (
                  <WebinarCard
                    upcoming
                    webinar={webinar}
                    key={`${webinarIndex}-${webinar.title}`}
                  />
                );
              }
              return null;
            })}
            {filteredWebinars?.onDemandWebinars?.map((webinar, webinarIndex) => {
              const date = new Date(webinar.date);
              if (
                (date > currentDate && webinar.webinar_registration_link !== "") ||
                date < currentDate
              ) {
                return <WebinarCard webinar={webinar} key={`${webinarIndex}-${webinar.title}`} />;
              }
              return null;
            })}
          </section>
          {loading && <span className="webinars_list-spinner" />}
        </section>
      </section>
    </section>
  );
};
